import { classes } from "../../../helper";
import styles from "./SiteSelector.module.css";
import { ProductionAreaTab } from "./types";

type Props = {
  tabs: ProductionAreaTab[];
  activeProductionArea?: string;
  onSelect: (productionArea: string) => void;
};

function ProductionAreaTabs({ tabs, activeProductionArea, onSelect }: Props) {
  if (tabs.length <= 1) return null;

  return (
    <div className={styles.productionAreaTabs} role="tablist">
      {tabs.map((tab) => {
        const active = tab.productionArea === activeProductionArea;

        return (
          <button
            key={tab.productionArea}
            type="button"
            role="tab"
            aria-selected={active}
            className={classes(
              styles.productionAreaTab,
              active ? styles.productionAreaTabActive : ""
            )}
            onClick={() => onSelect(tab.productionArea)}
          >
            <span>{tab.productionArea}</span>
          </button>
        );
      })}
    </div>
  );
}

export default ProductionAreaTabs;
